module.exports = __webpack_public_path__ + "img/3.f5d7f3ca.png";